<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="700px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-chart-line</v-icon>
              <span class="px-3">{{ $t('Add Closing Entry') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end />
            </v-flex>

            <v-layout row wrap>
              <v-flex xs8 class="pa-2">
                <v-text-field
                  v-model="form.closing_title"
                  :label="$t('Title')"
                  box
                  name="closing_title"
                  hide-details
                  background-color="white"
                  :error="errors.has('closing_title')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs4 class="pa-2">
                <v-menu v-model="dateMenu" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="form.closing_date"
                    :label="`${$t('Date')} *`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    name="closing_date"
                    background-color="white"
                    autocomplete="off"
                    :error="errors.has('closing_date')"
                    v-validate="'required|date_format:yyyy-MM-dd'"
                  />
                  <v-date-picker @change="dateMenu = false" v-model="form.closing_date" />
                </v-menu>
              </v-flex>

              <v-flex xs12 sm12 md12 class="pa-2">
                <v-textarea
                  v-model="form.closing_note"
                  :label="`${$t('Note')}`"
                  name="closing_note"
                  hide-details
                  box
                  height="80"
                  background-color="white"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnAddLoading: false,
      form: {
        closing_title: '',
        closing_date: '',
        closing_note: ''
      },
      dateMenu: false,
      keepForm: false
    }
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addClosingEntry: 'closingEntries/addClosingEntry'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.closing_date = this.$moment()
        .format()
        .substr(0, 10)

      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('income-focus-me').focus()
      })
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnAddLoading = true
          let formData = new FormData(event.target)

          this.addClosingEntry(formData)
            .then(() => {
              this.btnAddLoading = false
              this.$emit('reset-datatable')
              if (this.keepForm) {
                this.resetForm()
              } else {
                this.$emit('hidemodal')
              }
            })
            .catch(() => {
              this.btnAddLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
